import React, { useState } from "react"
import HOC from "../component/HOC"
import BaseUrl from '../BaseUrl'
import axios from 'axios'
import swal from "sweetalert";
import { FiClock, FiHelpCircle, FiMail, FiMessageCircle, FiSend, FiShield, FiUser } from "react-icons/fi";


const HelpCenter = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const AddHelp = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const token = await localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            },
        };
        const url = BaseUrl() + "api/help/add/help";
        const data = {
            name: name,
            email: email,
            query: message,
        };
        try {
            const response = await axios.post(url, data, auth);
            if (response.data.ResponseCode === 200) {
                swal(response.data.ResponseMessage, {
                    icon: "success"
                });
                setName("");
                setEmail("");
                setMessage("");
            }

        } catch (error) {
            swal("Unable to submit your request. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    }


    return (
        <main className="mx-auto flex w-full max-w-7xl flex-col gap-4">
            <section className="relative overflow-hidden rounded-[1.9rem] border border-white/70 bg-gradient-to-br from-sky-500 via-blue-600 to-blue-800 px-4 py-4 text-white shadow-2xl shadow-sky-900/20 sm:px-5">
                <div className="pointer-events-none absolute -right-16 -top-20 h-40 w-40 rounded-full bg-white/20 blur-3xl" />
                <div className="pointer-events-none absolute -bottom-20 left-10 h-36 w-36 rounded-full bg-cyan-300/20 blur-3xl" />
                <div className="relative flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-white/15 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-100 ring-1 ring-white/20 backdrop-blur">
                            <FiHelpCircle className="h-3.5 w-3.5" />
                            Support Desk
                        </div>
                        <h1 className="text-xl font-bold tracking-tight sm:text-2xl">Help Center</h1>
                        <p className="mt-1.5 max-w-2xl text-sm leading-5 text-sky-100">
                            Send a request to our support team and we&apos;ll help you move forward.
                        </p>
                    </div>
                    <div className="grid w-full gap-2 rounded-2xl bg-white/15 p-3 ring-1 ring-white/20 backdrop-blur sm:max-w-xs">
                        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-sky-100">Support Status</p>
                        <div className="flex items-end justify-between">
                            <span className="text-lg font-bold">Online</span>
                            <span className="rounded-full bg-white px-2.5 py-1 text-[11px] font-bold text-blue-700">Ready</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="grid gap-4 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)]">
                <aside className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur sm:p-5">
                    <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-white shadow-lg shadow-sky-500/25">
                        <FiMessageCircle className="h-7 w-7" />
                    </div>
                    <h2 className="text-xl font-extrabold tracking-tight text-slate-950">How can we help?</h2>
                    <p className="mt-2 text-sm leading-6 text-slate-500">
                        Share as much context as possible so the support team can respond with the right guidance.
                    </p>
                    <div className="mt-5 grid gap-3">
                        <div className="rounded-2xl bg-sky-50 p-3 ring-1 ring-sky-100">
                            <div className="flex items-center gap-2 text-sm font-bold text-slate-900">
                                <FiClock className="h-4 w-4 text-sky-600" />
                                Quick response
                            </div>
                            <p className="mt-1 text-xs leading-5 text-slate-500">We review new requests as soon as possible.</p>
                        </div>
                        <div className="rounded-2xl bg-sky-50 p-3 ring-1 ring-sky-100">
                            <div className="flex items-center gap-2 text-sm font-bold text-slate-900">
                                <FiShield className="h-4 w-4 text-sky-600" />
                                Secure support
                            </div>
                            <p className="mt-1 text-xs leading-5 text-slate-500">Your request is submitted through your authenticated account.</p>
                        </div>
                    </div>
                </aside>

                <form onSubmit={AddHelp} className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur sm:p-5">
                    <div className="mb-5 border-b border-slate-100 pb-4">
                        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Submit Request</p>
                        <h2 className="mt-1 text-xl font-extrabold text-slate-950">Tell us what happened</h2>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2">
                        <label className="block">
                            <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-slate-600">Full name</span>
                            <div className="relative">
                                <FiUser className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                                <input
                                    id="help-name"
                                    className="w-full rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-12 pr-4 text-sm font-semibold text-slate-900 outline-none transition placeholder:text-slate-400 hover:border-sky-200 hover:bg-white focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100"
                                    type="text"
                                    placeholder="Enter your name"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value);
                                    }}
                                />
                            </div>
                        </label>

                        <label className="block">
                            <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-slate-600">Email address</span>
                            <div className="relative">
                                <FiMail className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                                <input
                                    id="help-email"
                                    className="w-full rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-12 pr-4 text-sm font-semibold lowercase text-slate-900 outline-none transition placeholder:text-slate-400 hover:border-sky-200 hover:bg-white focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100"
                                    type="email"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                    }}
                                />
                            </div>
                        </label>
                    </div>

                    <label className="mt-4 block">
                        <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-slate-600">How can we help?</span>
                        <textarea
                            id="message"
                            rows={6}
                            className="block w-full resize-none rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm font-medium text-slate-900 outline-none transition placeholder:text-slate-400 hover:border-sky-200 hover:bg-white focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100"
                            placeholder="Describe your question or issue in detail..."
                            value={message}
                            onChange={(e) => {
                                setMessage(e.target.value);
                            }}
                        />
                    </label>

                    <div className="mt-5 flex justify-end">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-7 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100 disabled:pointer-events-none disabled:opacity-60 sm:w-auto"
                        >
                            <FiSend className="h-4 w-4" />
                            {isSubmitting ? "Submitting..." : "Submit request"}
                        </button>
                    </div>
                </form>
            </section>
        </main>
    )
}

export default HOC(HelpCenter)
